/* LEGEND — how old MV-5's read is, as the chart's Vision layer and the verdict ribbon show it.

   A read is LIVE for READ_LIVE_MS after its frame (a 1-minute bar's close, plus slack), then it is the LAST READ:
   still drawn (faded) and labelled with its time — never cleared. No bar means no new frame: a halt, a thin stock
   with no prints, the hours MV-5 does not score (it runs 04:00–20:00 ET). The read from before is still the read
   (owner, 2026-10-22: "it must show the last feed"). Only a symbol MV-5 has never read shows nothing. */

/** a frame newer than this is live (2.5 min: the bar cadence plus slack) */
export const READ_LIVE_MS = 150_000;

export type ReadState = 'none' | 'live' | 'last';

export function readState(frameTs: number | null | undefined, now: number): ReadState {
  if (typeof frameTs !== 'number' || !Number.isFinite(frameTs) || frameTs <= 0) return 'none';
  return now - frameTs <= READ_LIVE_MS ? 'live' : 'last';
}

let _day: Intl.DateTimeFormat | null = null;
let _wd: Intl.DateTimeFormat | null = null;
let _clock: Intl.DateTimeFormat | null = null;

/** "19:59:30" (ET) for a read from today, "Tue 19:59:30" for one from another ET day */
export function etWhen(ts: number, now: number): string {
  if (!_day) _day = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' });
  if (!_wd) _wd = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short' });
  if (!_clock) _clock = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  const clock = _clock.format(new Date(ts));
  return _day.format(new Date(ts)) === _day.format(new Date(now)) ? clock : _wd.format(new Date(ts)) + ' ' + clock;
}
